import styled from 'styled-components';

const CheckboxContainer = styled.td`
	display: flex;
	justify-content: flex-end;
	.custom .custom__label:after {
		right: -2px;
	}
	.custom .custom__label:before {
		right: 0;
	}
	.custom .custom__label {
		cursor: pointer;
	}
`;

export default CheckboxContainer;
